import { useState } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { ToggleGroup } from '@bambi/component-library/src/components/ToggleGroup/ToggleGroup';
import { useNavigate, useParams } from 'react-router';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { FormErrorMessage } from 'src/common/FormErrorMessage';

import { dispatcherSlice } from '../../dispatcher.slice';
import { TripAcceptRequestModal } from '../../modals/requestedTrips/accept/TripAcceptRequestModal';
import { useAcceptTripRequestConfirmModalProps } from '../../modals/requestedTrips/accept/useAcceptTripRequestConfirmModalProps';
import { onApplyRunBambiRun } from '../../onApplyRunBambiRun';
import { NewAssignmentsList } from './NewAssignmentsList';
import { NotAssignedList } from './NotAssignedList';
import { ReassignmentList } from './ReassignmentList';

export function RunBambiRunReview() {
  const runBambiRunResult = useAppSelector(
    (state) => state.dispatcher.runBambiRunResult
  );
  const tripAssignmentsToApplyIds = useAppSelector(
    (state) => state.dispatcher.tripAssignmentsToApplyIds
  );
  const runBambiRunError = useAppSelector(
    (state) => state.dispatcher.runBambiRunError
  );
  const selectedDate = useAppSelector((state) => state.dispatcher.selectedDate);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { rbrJobId } = useParams();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [runBambiRunApplyError, setRunBambiRunApplyError] = useState('');
  const tripAcceptRequestModalProps = useAcceptTripRequestConfirmModalProps();
  if (!runBambiRunResult) return null;

  const ASSIGNMENT_TAB_TITLES = [
    `New Assignments (${runBambiRunResult.new_trip_assignments.length || 0})`,
    `Reassignments (${runBambiRunResult.trip_reassignments.length || 0})`,
    `Not Assigned (${runBambiRunResult.trips_not_assigned.length || 0})`,
  ];

  return (
    <>
      <ToggleGroup
        options={ASSIGNMENT_TAB_TITLES}
        selectedIndex={selectedTabIndex}
        onSelect={setSelectedTabIndex}
      />
      {selectedTabIndex === 0 && <NewAssignmentsList />}
      {selectedTabIndex === 1 && <ReassignmentList />}
      {selectedTabIndex === 2 && <NotAssignedList />}
      <div
        className={`flex flex-col items-center justify-center gap-2.5 rounded-[10px] bg-white py-2 px-5 text-center font-normal text-[rgba(51,51,51,1)] drop-shadow-lg`}
      >
        {!!runBambiRunApplyError && (
          <div className="w-full text-left">
            <FormErrorMessage>{runBambiRunApplyError}</FormErrorMessage>
          </div>
        )}
        {!!runBambiRunError && (
          <div className="w-full text-left">
            <FormErrorMessage>{runBambiRunError}</FormErrorMessage>
          </div>
        )}
        <div className="flex w-full items-center justify-between gap-4">
          <Button
            variant="primary-danger"
            className="flex-grow"
            onClick={() => {
              // TODO: Do we cancel the job on the backend or just leave it?
              dispatch(dispatcherSlice.actions.onCancelRunBambiRun());
              navigate(`/dispatch/${selectedDate}`);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="flex-grow"
            disabled={Boolean(runBambiRunError)}
            onClick={async () => {
              const hasRequestedTripsToApply =
                runBambiRunResult.new_trip_assignments
                  .filter((trip) => tripAssignmentsToApplyIds[trip.id])
                  .some((trip) => trip.status === 'requested');
              if (hasRequestedTripsToApply) {
                dispatch(
                  dispatcherSlice.actions.onApplyRunBambiRunWithRequestedTrips()
                );
              } else {
                if (typeof rbrJobId !== 'string') {
                  setRunBambiRunApplyError('No job id found');
                  return;
                }
                setRunBambiRunApplyError('');
                try {
                  await dispatch(
                    onApplyRunBambiRun({
                      rbrJobId,
                    })
                  );
                  navigate(`/dispatch/${selectedDate}`);
                } catch (e) {
                  setRunBambiRunApplyError('Error applying Run Bambi Run');
                }
              }
            }}
          >
            Apply
          </Button>
          <TripAcceptRequestModal props={tripAcceptRequestModalProps} />
        </div>
      </div>
    </>
  );
}
